import { Connection } from '@solana/web3.js';

import config from '@/config';

let connectionInstance: Connection | null = null;

/**
 * Get or create a Solana connection instance (singleton pattern)
 * @returns Solana Connection instance
 */
export function getConnection(): Connection {
  if (!connectionInstance) {
    const rpcUrl = config.SOLANA_RPC_URL || 'https://api.devnet.solana.com';
    connectionInstance = new Connection(rpcUrl, 'confirmed');
    console.log(`🔗 Created Solana connection to: ${rpcUrl}`);
  }
  return connectionInstance;
}

/**
 * Reset the connection instance (useful for switching networks)
 */
export function resetConnection(): void {
  connectionInstance = null;
}

// Swap RPC connection for dust swap feature (uses same connection for now)
let swapConnectionInstance: Connection | null = null;

/**
 * Get or create a Solana connection for swap operations
 * Uses the same RPC as the main connection
 */
export function getSwapConnection(): Connection {
  if (!swapConnectionInstance) {
    const rpcUrl = config.SOLANA_RPC_URL || 'https://api.devnet.solana.com';
    swapConnectionInstance = new Connection(rpcUrl, 'confirmed');
    console.log(`🔗 Created Swap connection to: ${rpcUrl}`);
  }
  return swapConnectionInstance;
}

/**
 * Get the swap RPC URL
 */
export function getSwapRpcUrl(): string {
  return config.SOLANA_RPC_URL || 'https://api.devnet.solana.com';
}
